import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css'
import { IframeProvider } from './context/IframeContext';
import Dashboard from './views/Dashboard';
import { setOrgId, setCountyIds } from "./utils/dashboardUtils";
import { MetricCategoriesProvider } from './context/MetricCategoriesContext';
import { LayersProvider } from './context/LayersContext';
import { MetadataProvider } from './context/MetadataContext';
import StorymapPage from './components/storymap/StorymapPage';
import Intro from './components/storymap/Intro';
import ScrollbarRouteClass from './components/routing/ScrollbarRouteClass';
import { CountyIndicatorsProvider } from './context/CountyIndicatorsContext';

function App() {

  // for now, commerceorigin can be set to 8080
  //const allowedOrigin = "*";
  // state to track if the message has been sent to the parent application
  const [messageSent, setMessageSent] = useState(false);

  useEffect(() => {

    // If app is loaded within an iframe, send a "ready" message to the parent window
    if (!messageSent && window.parent !== window) {
      window.parent.postMessage({ message: "ready" }, "*");
      setMessageSent(true);
    }

    // Iframe events
    window.addEventListener("message", receiveMessage, false);

    return () => {
      // Cleanup event listener when component unmounts
      window.removeEventListener("message", receiveMessage);
    };
  }, [messageSent]);

  // Receive message - process Iframe requests
  function receiveMessage(event: MessageEvent) {
    event.preventDefault();

    if (event.data.message !== undefined) {
      switch (event.data.message) {
        case "update":
          setOrgId(event.data.params.organization_id || 12);

          if(event.data.params.area_view.geo_details != undefined){
            console.log("checking for counties: ", event.data);
            var counties = event.data.params.area_view.geo_details?.find((x: any) => x.lod === "county");
            console.log("found counties: ", counties);
            setCountyIds(counties?.ids ?? '');
          }

          break;
        case "process-token":
          handleToken(event.data.params.token);
          break;
      }
    }
  }

  // handleToken - Process the token received from parent window
  function handleToken(token: any) {
    // Log our token for now
    console.log("Received token:", token);
  };
  return (
    <IframeProvider>
      <MetricCategoriesProvider>
        <MetadataProvider>
          <CountyIndicatorsProvider>
            <LayersProvider>
              <Router>
                <ScrollbarRouteClass/>
                <Routes>
                  <Route path="/" element={<Dashboard/>} />
                  {/* Dashboard Content */}
                  <Route path="/dashboard/:tab" element={<Dashboard/>}/>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/storymap" element={<StorymapPage />}/>
                  <Route path="/intro" element={<Intro/>}/>
                </Routes>
              </Router>
            </LayersProvider>
          </CountyIndicatorsProvider>
        </MetadataProvider>
      </MetricCategoriesProvider>
    </IframeProvider>
  )
}

export default App
